import logger from "@/lib/logging/logger";
import { useStore } from "@/store";

useStore.subscribe(
	(state) => state.sessionId,
	(sessionId) => {
		//@ts-expect-error
		logger.injectCommonProp("pandas_session_id", sessionId);
	},
	{
		fireImmediately: true,
	},
);

useStore.subscribe(
	(state) => state?.imeiInfo?.identification.extracted_metadata,
	(metadata) => {
		const modelName = Array.isArray(metadata?.modelName) ? metadata.modelName.join(" ") : metadata?.modelName;
		logger.injectCustomProp(
			"pandas_device_model",
			metadata?.brand && modelName ? `${metadata.brand} ${modelName}` : "",
		);
	},
	{
		fireImmediately: true,
	},
);

useStore.subscribe(
	(state) => state?.imeiInfo?.identification.identifier,
	(imei) => {
		//@ts-expect-error
		logger.injectCommonProp("pandas_identifier", imei);
	},
	{
		fireImmediately: true,
	},
);
